import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Typography, Autocomplete, TextField, Button, CircularProgress, Table, TableBody, TableCell, TableContainer, TableRow, Paper, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { BASE_URL } from '../../App';
import { TableHead } from '@mui/material';
import { createFilterOptions } from '@mui/material';


const SpareConsumedReport = () => {
    const [branch, setBranch] = useState(null);
    const [month, setMonth] = useState(null);
    const [year, setYear] = useState(null);
    const [filterType, setFilterType] = useState('');

    const [branches, setBranches] = useState([]);
    const [months, setMonths] = useState([]);
    const [years, setYears] = useState([]);

    const [psgList, setPsgList] = useState([]);
    const [selectedPsg, setSelectedPsg] = useState(null);
    const [itemList, setItemList] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [descList, setDescList] = useState([]);
    const [selectedDesc, setSelectedDesc] = useState(null);
    const [ASCList, setASCList] = useState([]);
    const [selectedASC, setSelectedASC] = useState(null);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const login_id = localStorage.getItem("LOGIN_ID");
    const usertype = localStorage.getItem("usertype");
    const user_branch = localStorage.getItem("BRANCH_CODE");
    useEffect(() => {
        fetchFilters();
    }, []);
    const filterOptions = createFilterOptions({
        matchFrom: 'any',
        stringify: (option) => `${option.label} ${option.value}` 
    });
    
    
    const fetchFilters = async () => {
        try {
            const branchRes = await axios.post(`${BASE_URL}/fillbranchforspare`, {
                user_branch: user_branch,
                login_id: login_id
               
            });

            const branchOptions = branchRes.data.branches.map(item => ({
                label: `${item.BRANCH_CODE} - ${item.BRANCH_NAME}`,
                value: item.BRANCH_CODE
            }));
            setBranches(branchOptions);

            const filtersRes = await axios.post(`${BASE_URL}/loadFilters`);

            const monthOptions = filtersRes.data.months.map(month => ({
                label: month,
                value: month
            }));
            const yearOptions = filtersRes.data.years.map(year => ({
                label: year.toString(),
                value: year.toString()
            }));

            setMonths(monthOptions);
            setYears(yearOptions);

            const currentMonth = filtersRes.data.currentMonth;
            const currentYear = filtersRes.data.currentYear;

            setMonth(monthOptions.find(m => m.value === currentMonth));
            setYear(yearOptions.find(y => y.value === currentYear.toString()));

        } catch (error) {
            console.error('Error fetching filters:', error);
          //  Swal.fire('Error', 'Failed to load filters', 'error');
        }
    };

    const fetchPsgList = async () => {
        try {
            const res = await axios.post(`${BASE_URL}/loadPsg`, {
                branch: branch?.value
            });

            const psgOptions = res.data.psgList.map(item => ({
                label: item.label, 
                value: item.value
            }));

            setPsgList(psgOptions);
        } catch (error) {
            console.error('Error fetching PSG list:', error);
           // Swal.fire('Error', 'Failed to load PSG list', 'error');
        }
    };

    const fetchItemList = async () => {
        try {
            const res = await axios.post(`${BASE_URL}/loaditem`, {
                branchcode: branch?.value,
                month: month?.value,
                year: year?.value
            });
    
           
            const itemOptions = res.data.items.map(item => ({
                label: item.itemdescription.trim(), 
                value: item.itemcode.trim()  
            }));
    
            setItemList(itemOptions);
        } catch (error) {
            console.error('Error fetching item list:', error);
            //Swal.fire('Error', 'Failed to load item list', 'error');
        }
    };
    
    const fetchDescList = async () => {
        try {
            const res = await axios.post(`${BASE_URL}/loadDesc`, {
                branchcode: branch?.value,
                month: month?.value,
                year: year?.value
            });
    
          
            const descOptions = res.data.items.map(item => ({
                label: item.trim(),
                value: item.trim()  
            }));
    
            setDescList(descOptions);
        } catch (error) {
            console.error('Error fetching Desc list:', error);
            Swal.fire('Error', 'Failed to load Desc list', 'error');
        }
    };
  
    const fetchASCList = async () => {
        try {
            const res = await axios.post(`${BASE_URL}/loadASC`, {
                branch: branch?.value,
                month: month?.value,
                year: year?.value
            });
    
        
            const ASCOptions = res.data.map(item => ({
                label: item.asc_name,   
                value: item.asc_code       
            }));
    
            setASCList(ASCOptions);
        } catch (error) {
            console.error('Error fetching ASC list:', error);
          //  Swal.fire('Error', 'Failed to load ASC list', 'error');
        }
    };
    
    
    const handleFilterChange = (event) => {
        const value = event.target.value;
        setFilterType(value);
    
        if (value === 'PSG - Wise') {
            fetchPsgList();
        } else {
            setPsgList([]);
            setSelectedPsg(null);
        }
    
        if (value === 'ITEM - Wise') {
            if (branch && month && year) {
                fetchItemList();
                fetchDescList();
            } else {
                Swal.fire('Warning', 'Please select Branch, Month, and Year first', 'warning');
            }
        } 
        
        
        else {
            setItemList([]);
            setSelectedItem(null);
            setDescList([]);
            setSelectedDesc(null);
        }
        if (value === 'ASC - Wise') {
            fetchASCList();
        } else {
            setASCList([]);
            setSelectedASC(null);
        }
    };

    const fetchData = async () => {
      setData([]);
      if (!branch || !month || !year || !filterType) {
          Swal.fire('Warning', 'Please select all filters', 'warning');
          return;
      }
      if (filterType === 'PSG - Wise' && !selectedPsg) {
          Swal.fire('Warning', 'Please select a PSG', 'warning');
          return;
      }
      if (filterType === 'ITEM - Wise' && (!selectedItem)) {
          Swal.fire('Warning', 'Please select both Item and Description', 'warning');
          return;
      }
      if (filterType === 'ASC - Wise' && !selectedASC) {
          Swal.fire('Warning', 'Please select an ASC', 'warning');
          return;
      }
  
      // Show SweetAlert loader
      Swal.fire({
          title: 'Loading Data...',
          html: 'Please wait while the data is being fetched...',
          allowOutsideClick: false,
          didOpen: () => {
              Swal.showLoading();
          }
      });
  
      try {
          const response = await axios.post(`${BASE_URL}/loadGrid`, {
              branch: branch?.value,   
              month: month?.value,          
              year: year?.value,            
              filtertype: filterType,      
              psg: selectedPsg?.value || 'ALL',    
              itemdesc: selectedItem?.value || 'ALL',  
              asccode: selectedASC?.value || 'ALL'  
          });
  
          const fetchedData = response.data;
  
          if (branch.value === "ALL") {
              // Convert data to Excel format
              const worksheet = XLSX.utils.json_to_sheet(fetchedData);
              const workbook = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(workbook, worksheet, 'SpareConsumedData');
  
              // Download the Excel file
              XLSX.writeFile(workbook, `Spare_Consumed_Report_${month.value}_${year.value}.xlsx`);
              
              // Show success message
              Swal.fire('Success', 'Excel file exported successfully!', 'success');
          } else {
              // Set data to display in the table
              setData(fetchedData);
          }
  
      } catch (error) {
          console.error('Error fetching data:', error);
  
          // Show error message
          Swal.fire({
              icon: 'error',
              title: 'Failed to Load Data',
              text: 'An error occurred while fetching the data. Please try again.',
          });
  
      } finally {
          // Close the SweetAlert loader
          Swal.close();
      }
  };
  
    
    const handleExportExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'SpareConsumedData');

        XLSX.writeFile(workbook, `Spare_Consumed_Report_${month.value}_${year.value}.xlsx`);
        Swal.fire('Success', 'Excel file exported successfully!', 'success');
    };

    return (
        <Box display="flex" flexDirection="column" alignItems="center" sx={{ minHeight: '100vh', backgroundColor: '#f0f0f0', padding: 3 }}>
            <Card sx={{ width: '90%', maxWidth: 1200, boxShadow: 3, padding: 3, marginBottom: 3 }}>
                <CardContent>
                    <Typography variant="h4" gutterBottom sx={{ textAlign: 'center', fontWeight: 'bold', color: '#3f51b5' }}>
                        {/* Service Complaint Spares Report */}
                    </Typography>

                    <Box display="flex" justifyContent="space-between" sx={{ marginTop: 3 }}>
 
    <Autocomplete
        options={branches}
        value={branch}
        onChange={(event, newValue) => setBranch(newValue)}
        getOptionLabel={(option) => option.label}
        filterOptions={filterOptions}  
        renderInput={(params) => <TextField {...params} label="Select Branch" />}
        sx={{ width: '23%' }}
    />

                        <Autocomplete
                            options={months}
                            value={month}
                            onChange={(event, newValue) => setMonth(newValue)}
                            getOptionLabel={(option) => option.label}
                            renderInput={(params) => <TextField {...params} label="Select Month" />}
                            sx={{ width: '23%' }}
                        />

                        <Autocomplete
                            options={years}
                            value={year}
                            onChange={(event, newValue) => setYear(newValue)}
                            getOptionLabel={(option) => option.label}
                            renderInput={(params) => <TextField {...params} label="Select Year" />}
                            sx={{ width: '23%' }}
                        />

                        <FormControl sx={{ width: '23%' }}>
                            <InputLabel id="filter-type-label">Select</InputLabel>
                            <Select
                                labelId="filter-type-label"
                                value={filterType}
                                onChange={handleFilterChange}
                                displayEmpty
                            >
                                <MenuItem value="PSG - Wise">PSG - Wise</MenuItem>
                                <MenuItem value="ITEM - Wise">ITEM - Wise</MenuItem>
                                <MenuItem value="ASC - Wise">ASC - Wise</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>

                    {filterType === 'PSG - Wise' && (
                     <Box display="flex" justifyContent="center" sx={{ marginTop: 3 }}>
                     <Autocomplete
                         key={psgList.length}
                         options={psgList}
                         value={selectedPsg}   
                         onChange={(event, newValue) => setSelectedPsg(newValue)}
                         getOptionLabel={(option) => `${option?.value}-${option?.label}`}
                         isOptionEqualToValue={(option, value) => option.value === value.value}  
                         renderInput={(params) => <TextField {...params} label="Select PSG" />}
                         sx={{ width: '50%' }}
                     />
                 </Box>
                    )}

{filterType === 'ITEM - Wise' && (
    <>
        <Box display="flex" justifyContent="center" sx={{ marginTop: 3 }}>
            <Autocomplete
                key={itemList.length}
                options={itemList}
                value={selectedItem}
                onChange={(event, newValue) => setSelectedItem(newValue)}
                getOptionLabel={(option) => `${option.value} - ${option.label}` || ''}
                renderInput={(params) => <TextField {...params} label="Select Item" />}
                sx={{ width: '50%' }}
            />
        </Box>
        <Box display="none" justifyContent="center" sx={{ marginTop: 3 }}>
            <Autocomplete
                key={descList.length}
                options={descList}
                value={selectedDesc}
                onChange={(event, newValue) => setSelectedDesc(newValue)}
                getOptionLabel={(option) => option?.label || ''}
                renderInput={(params) => <TextField {...params} label="Select Description" />}
                sx={{ width: '50%' }}
            />
        </Box>
    </>
)}

                    {filterType === 'ASC - Wise' && (
    <Box display="flex" justifyContent="center" sx={{ marginTop: 3 }}>
        <Autocomplete
            key={ASCList.length}
            options={ASCList}
            value={selectedASC}
            onChange={(event, newValue) => setSelectedASC(newValue)}
            getOptionLabel={(option) => `${option.value} - ${option.label}` || ''}
            isOptionEqualToValue={(option, value) => option.value === value.value}  
            renderInput={(params) => <TextField {...params} label="Select ASC" />}
            sx={{ width: '50%' }}
        />
    </Box>
)}

                    <Box display="flex" justifyContent="center" sx={{ marginTop: 3 }}>
                        <Button variant="contained" color="primary" onClick={fetchData} sx={{ marginRight: 2 }}>
                            {loading ? <CircularProgress size={24} color="inherit" /> : 'Fetch Data'}
                        </Button>

                        <Button variant="contained" color="success" onClick={handleExportExcel} disabled={data.length === 0}>
                            Export to Excel
                        </Button>
                    </Box>
                </CardContent>
            </Card>

            {data.length > 0 && (
    <Card sx={{ width: '90%', maxWidth: 1200, boxShadow: 3, padding: 3, marginTop: 3 }}>
        <CardContent>
            {/* <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                Report Data
            </Typography> */}

            <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
    <Table stickyHeader>
        <TableHead>
            <TableRow sx={{ backgroundColor: '#1976d2' }}>  
                <TableCell sx={{ backgroundColor: '#1976d2', color: 'white', fontWeight: 'bold', minWidth: 150 }}>Branch Code</TableCell>
                <TableCell sx={{ backgroundColor: '#1976d2', color: 'white', fontWeight: 'bold', minWidth: 150 }}>Serial No</TableCell>
                <TableCell sx={{ backgroundColor: '#1976d2', color: 'white', fontWeight: 'bold', minWidth: 150 }}>Doc No</TableCell>
                <TableCell sx={{ backgroundColor: '#1976d2', color: 'white', fontWeight: 'bold', minWidth: 150 }}>SCR No</TableCell>
                <TableCell sx={{ backgroundColor: '#1976d2', color: 'white', fontWeight: 'bold', minWidth: 180 }}>SCR Date</TableCell>
                <TableCell sx={{ backgroundColor: '#1976d2', color: 'white', fontWeight: 'bold', minWidth: 150 }}>Mat Code</TableCell>
                <TableCell sx={{ backgroundColor: '#1976d2', color: 'white', fontWeight: 'bold', minWidth: 200 }}>Item Desc</TableCell>
                <TableCell sx={{ backgroundColor: '#1976d2', color: 'white', fontWeight: 'bold', minWidth: 150 }}>PSG</TableCell>
                <TableCell sx={{ backgroundColor: '#1976d2', color: 'white', fontWeight: 'bold', minWidth: 150 }}>Party Code</TableCell>
                <TableCell sx={{ backgroundColor: '#1976d2', color: 'white', fontWeight: 'bold', minWidth: 200 }}>Party Name</TableCell>
                <TableCell sx={{ backgroundColor: '#1976d2', color: 'white', fontWeight: 'bold', minWidth: 200 }}>Service Type</TableCell>
                <TableCell sx={{ backgroundColor: '#1976d2', color: 'white', fontWeight: 'bold', minWidth: 200 }}>List of Spares</TableCell>
                <TableCell sx={{ backgroundColor: '#1976d2', color: 'white', fontWeight: 'bold', minWidth: 150 }}>Cost</TableCell>
            </TableRow>
        </TableHead>

        <TableBody>
            {data.map((item, index) => (
                <TableRow key={index}>
                    <TableCell>{item.BRANCH_CODE}</TableCell>
                    <TableCell>{item.SERIAL_NO}</TableCell>
                    <TableCell>{item.DOC_NO}</TableCell>
                    <TableCell>{item.SCR_NO}</TableCell>
                    <TableCell>{item.SCR_DATE}</TableCell>
                    <TableCell>{item.MAT_CODE}</TableCell>
                    <TableCell>{item.ITEMDESC}</TableCell>
                    <TableCell>{item.PSG}</TableCell>
                    <TableCell>{item.PARTYCODE}</TableCell>
                    <TableCell>{item.PARTYNAME}</TableCell>
                    <TableCell>{item.SERVICE_TYPE}</TableCell>
                    <TableCell>{item.LIST_OF_SPARES}</TableCell>
                    <TableCell>{item.COST}</TableCell>
                </TableRow>
            ))}
        </TableBody>
    </Table>
</TableContainer>

        </CardContent>
    </Card>
)}

        </Box>
    );
};

export default SpareConsumedReport;